import { render } from "./IconForkRight.vue?vue&type=template&id=2c52d818"
import script from "./IconForkRight.vue?vue&type=script&lang=js"
export * from "./IconForkRight.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__